import { useMutation } from '@tanstack/react-query';
import { ApiService } from '@/_services/api.service';
import { useStreamingMessage } from '../streaming/useStreamingMessage';

/**
 * Mutation hook to generate AI response for a conversation
 * without loading existing messages (performance optimization).
 * Use this when messages are already cached on the client.
 */
export const useGenerateResponse = () => {
	const { startMessageStream } = useStreamingMessage();

	return useMutation({
		mutationFn: async (conversationId: string) => {
			return conversationId;
		},
		onSuccess: (conversationId) => {
			// Start streaming AI response without loading existing messages
			startMessageStream(async (signal) => ApiService.GenerateAIResponse({ conversationId, signal }), {
				conversationId,
				suppressLockErrors: true,
				skipMessageEvents: true, // Messages already in cache
				skipStreamStart: false // Still need stream_start for the AI response
			});
		}
	});
};
